// src/components/Article.js
import React, { useState } from 'react';
import ArticleForm from './ArticleForm';
import ArticleList from './ArticleList';

const Articles = () => {
  const [articles, setArticles] = useState([]);

  const addArticle = (article) => {
    setArticles([...articles, article]);
  };

  return (
    <div>
      <h1>Gestion des Articles</h1>
      <ArticleForm addArticle={addArticle} />
      <ArticleList articles={articles} />
    </div>
  );
};

export default Articles;
